<div #printContainer class="container bg-white py-4">
  <section class="pb-4 d-flex align-items-center justify-content-between">
    <h2 class="mb-0">
      <mat-icon [fontSet]="'fa'" [fontIcon]="'fa-check-circle'" [class]="'text-success'"></mat-icon>
      Confirmation
    </h2>

    <button (click)="printPreview()" color="accent" mat-flat-button>Print</button>
  </section>

  <ng-container *ngIf="summary">
    <div>The below {{ summary.requestType }} has been sent to Norfolk Southern for processing
      at {{ summary && summary.submittedTime | date: 'short' }}</div>
    <div>The equipment and corresponding Request Number(s) are:</div>

    <div class="container-fluid d-flex flex-column h-100 p-1">
      <div class="flex-grow-1 overflow-auto">
        <ns-grid
          [columns]="configs.columns"
          [config]="configs.headerOptions"
          [data]="summary.responseList"
          [gridOptions]="configs.options"
          [gridTitle]="configs.gridTitle"
          [name]="configs.gridName"
          class="d-inline-block">
        </ns-grid>
      </div>
    </div>

    <div class="mt-3">For further information please call Operations Service & Support at 800-635-5768.</div>
    <div>Thank you for choosing Norfolk Southern as your transportation provider.</div>
    <div>{{ summary.requestType }} for {{ summary.companyName }}.</div>
    <div>The following {{ summary.requestType }} has been submitted to Norfolk Southern for review and action.</div>

    <section class="mt-4">
      <button *ngIf="type === submitType.EDIT && summary" (click)="submitAnother()" aria-label="Submit Another Request"
              class="mr-2"
              color="accent"
              mat-flat-button>
        Submit Another Request
      </button>

      <button *ngIf="type === submitType.VIEW && summary" [routerLink]="['/home/diversions/review-details']" aria-label="Return To List"
              class="mr-2" color="accent" mat-flat-button>
        Return To List
      </button>

      <button *ngIf="reshipCars.length > 0" (click)="navigateReship()" aria-label="Proceed With Reship"
              color="accent" mat-flat-button>
        Proceed With Reship
      </button>
    </section>

    <ng-container *ngIf="reshipCars.length > 0">
      <div class="mt-4">
        <strong>Car(s) potentially eligible for reship:</strong>
      </div>
      <div class="mb-3">{{ reshipCars.join(', ') }}</div>
    </ng-container>
  </ng-container>

  <div class="mt-4">
    <ng-diversions-review-form
      [type]="summary?.requestType"
      [form]="form"
      [screenPath]="gridPaths.SUBMIT_DETAILS">
    </ng-diversions-review-form>
  </div>
</div>
